import React, { Fragment } from 'react';
import { times, get, isEmpty } from 'lodash';

// local dependencies
import { withNetworkState } from 'ui/hoc/withNetworkState';
import { dateRangePickerPreloader as DateRangePickerPreloader } from 'ui/views/generic/dateRangePicker';
import { widgetPreloader as WidgetPreloader } from 'ui/views/generic/widgetPreloader';
import { getVisibleItems } from 'resolvers/getVisibleEntities';
import { reportsFilters as ReportsFiltersView } from 'ui/views/widgets/reportsFilters';
import { getLabel } from 'utils/getLabel';
import { BarChart } from 'modules/barChart';

// import { PieChart } from 'modules/pieChart';
import { PieChartHighCharts } from 'ui/containers/PieChartHighCharts';

/**
 * @type {object}
 * @desc A React presentation/dumb view component.
 * @example
 * import { callStatisticsReports as CallStatisticsReports } from 'ui/views/widgets/callStatisticsReports';
 *
 * // render
 * <CallStatisticsReports propName='propValue'/>
 */

/* ------------------ */

export const callStatisticsReportsSuccess = ( props ) => {

    const filterFields = getVisibleItems( props.structure.filtersConfig.fields, props.visibility );
    const widgetConfig = props.structure.widgetConfig;

    const chartData = [
        {
            data: props.pieChartData.chartData
        }
    ];

    return (
        <div className='ui-call-statistics-reports'>

            {/* Header and the filters */}
            <ReportsFiltersView
                filterFields={ filterFields }
                filterData={ props.filterData } // options and selected values
                widgetConfig={ widgetConfig }
                onOptionSelect={ props.onOptionSelect }
                onCagChange={ props.onCagChange }
            />

            {/* Reporting Charts */}
            <div className='ui-call-statistics-reports__charts'>
                <div className='ui-call-statistics-reports__charts__chart' >
                    {
                        ! props.isBarChartFetching && ! isEmpty( get( props, 'barGraphData' ) ) ? (
                            <div className='ui-call-statistics-reports__charts__chart__title'>
                                <div className='ui-call-statistics-reports__charts__chart__title__text'>
                                    { `${ getLabel( props.barGraphData.config.widgetConfig.title ) }: ` }
                                </div>
                                <div className='ui-call-statistics-reports__charts__chart__title__count'>
                                    { props.barGraphData.totalCalls }
                                </div>
                            </div>
                        ) : null
                    }

                    <BarChart
                        data = { props.barGraphData.chartData }
                        className='ui-call-statistics-reports__charts__chart__bar-chart'
                        isFetching={ props.isBarChartFetching }
                        onClickHandler={ props.onBarChartClickHandler }
                        width={ props.isPieChartVisible ? '880px' : '100%' }
                        noDataFoundLabel={ ! props.isBarChartFetching ? get( props, 'barGraphData.config.noDataView.title', {} ) : null }
                        networkStatus={ props.barGraphNetworkStatus }
                    />

                    {/* <BarChart
                        data = { props.barGraphData.chartData }
                        className='ui-call-statistics-reports__charts__chart__bar-chart'
                        isFetching={ props.isBarChartFetching }
                        onClickHandler={ props.onBarChartClickHandler }
                        width={ props.isPieChartVisible ? '900px' : '100%' }
                        noDataFoundLabel={ ! props.isBarChartFetching ? props.barGraphData.config.noDataView.title : null }
                    /> */}
                </div>

                { props.isPieChartVisible ? (
                    <Fragment>
                        <div className='ui-call-statistics-reports__charts__division'></div>
                    
                        <div className='ui-call-statistics-reports__charts__chart'>
                            {
                                ! props.isPieChartFetching ? (
                                    <div className='ui-call-statistics-reports__charts__chart__title'>
                                        <div className='ui-call-statistics-reports__charts__chart__title__text'>
                                            { `${ get( props, 'pieChartData.categoryName' ) }: ` }
                                        </div>
                                        <div className='ui-call-statistics-reports__charts__chart__title__count'>
                                            { props.pieChartData.totalCalls }
                                        </div>
                                    </div>
                                ) : null
                            }

                            {/* <PieChart
                                data = { props.pieChartData.chartData }
                                className='ui-call-statistics-reports__charts__chart__pie-chart'
                                isFetching={ props.isPieChartFetching }
                            /> */}

                            <PieChartHighCharts
                                data = { chartData }
                                className='ui-call-statistics-reports__charts__chart__pie-chart'
                                isFetching={ props.isPieChartFetching }
                                chartId={ 'stat-chart' }
                            />

                        </div>
                    </Fragment>
                ) : null }
            </div>
        </div>
    );
};

// set display name
callStatisticsReportsSuccess.displayName = 'callStatisticsReports';

// set default props
callStatisticsReportsSuccess.defaultProps = {};

// prop types
callStatisticsReportsSuccess.propTypes = {};

/* ********************************************** */

export const callStatisticsReportsPreloader = () => {

    return (
        <div className='ui-call-statistics-reports-preloader'>
            <div className='ui-call-statistics-reports-preloader__header'>
                <div className='ui-call-statistics-reports-preloader__header__title'></div>
                <DateRangePickerPreloader
                    className='ui-call-statistics-reports-preloader__header__date-range'
                />
                <div className='ui-call-statistics-reports-preloader__header__cag'>
                    <div className='ui-call-statistics-reports-preloader__header__cag__title'></div>
                    <div className='ui-call-statistics-reports-preloader__header__cag__choice'></div>
                </div>
            </div>

            <div className='ui-call-statistics-reports-preloader__filters'>
                { times( 4 ).map( index => {
                    return (
                        <div key={ index } className='ui-call-statistics-reports-preloader__filters__filter'>
                            <div className='ui-call-statistics-reports-preloader__filters__filter__title'></div>
                            <div className='ui-call-statistics-reports-preloader__filters__filter__options'>
                                { times( 4 ).map( _index => {
                                    return (
                                        <div key={ _index } className='ui-call-statistics-reports-preloader__filters__filter__options__option'>
                                            <div className='ui-call-statistics-reports-preloader__filters__filter__options__option__checkbox'></div>
                                            <div className='ui-call-statistics-reports-preloader__filters__filter__options__option__title'></div>
                                        </div>
                                    );
                                } ) }
                            </div>
                        </div>
                    );
                } ) }
            </div>
            <div className='ui-call-statistics-reports-preloader__chart'>
                <WidgetPreloader />
            </div>
        </div>
    );
};

// set display name
callStatisticsReportsPreloader.displayName = 'callStatisticsReportsPreloader';

// set default props
callStatisticsReportsPreloader.defaultProps = {};

// prop types
callStatisticsReportsPreloader.propTypes = {};

export const callStatisticsReports = withNetworkState( callStatisticsReportsPreloader, callStatisticsReportsSuccess );

